/**
 * Textos (`ca`) del tall «reception» de Qualitat i APPCC (OBR-167): el control de qualitat a la recepció des del
 * BackOffice — el mestre «Condicions de conservació» (rang i temperatura obligatòria), el registre manual d'una
 * recepció i el detall de l'albarà. Tall propi: no es toca `ca.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const receptionCa = {
  'backoffice.qualityReception': {
    // ── Mestre «Condicions de conservació» ────────────────────────────────────────────
    conservationTempMin: 'Temperatura mínima (°C)',
    conservationTempMax: 'Temperatura màxima (°C)',
    conservationRangeHint:
      'Deixa un límit en blanc si no n’hi ha. Fora del rang, la recepció demana decidir què es fa amb el gènere.',
    conservationRequires: 'Cal anotar la temperatura en rebre',
    conservationRequiresHint:
      'Qui rebi un article amb aquesta condició haurà d’escriure la temperatura amb què ha arribat.',
    conservationColRange: 'Rang en rebre',
    conservationColRequires: 'Temperatura obligatòria',
    conservationRangeNone: 'Sense rang',
    conservationRangeBetween: '{{min}} a {{max}} °C',
    conservationRangeAtLeast: 'Mínim {{min}} °C',
    conservationRangeAtMost: 'Màxim {{max}} °C',
    conservationRequiresYes: 'Sí',
    conservationRequiresNo: 'No',
    conservationTempInvalid: 'Escriu una temperatura entre {{min}} i {{max}} °C.',
    conservationRangeOrder: 'El mínim no pot ser més gran que el màxim.',

    // ── Control a la línia (registre manual de la recepció) ───────────────────────────
    sectionTitle: 'Control de qualitat',
    temperature: 'Temperatura (°C)',
    temperatureRequired: 'Temperatura (°C), obligatòria',
    temperatureRange: 'Rang acceptable: {{range}}',
    temperatureStatus_ok: 'Dins del rang',
    temperatureStatus_low: 'Per sota del mínim',
    temperatureStatus_high: 'Per sobre del màxim',
    temperatureMissing: 'Cal anotar la temperatura.',
    temperatureUnreadable: 'Escriu una temperatura vàlida (per exemple 3,5 o -18).',
    packaging: 'Envàs',
    labeling: 'Etiquetatge',
    checkNone: 'Sense controlar',
    checkOk: 'OK',
    checkKo: 'KO',
    issuesNotice: 'Alguna cosa no quadra: {{list}}. Es registrarà una no conformitat.',
    issue_temperature_out_of_range: 'temperatura fora de rang',
    issue_packaging_ko: 'envàs en mal estat',
    issue_labeling_ko: 'etiquetatge incorrecte',
    decision: 'Decisió',
    decisionNone: 'Tria què es fa',
    decision_accepted: 'Accepta el gènere',
    decision_accepted_with_incident: 'Accepta amb incidència',
    decision_rejected: 'Rebutja el gènere',
    decisionMissing: 'Cal triar què es fa amb aquesta entrada.',
    rejectedHint:
      'Rebutjar el gènere el bloqueja a les existències i deixa una devolució pendent al proveïdor.',
    derivedNok: 'No conforme pel control de qualitat',
    missingBlocker: 'el control de qualitat d’alguna entrada (temperatura o decisió)',

    // ── Detall de l’albarà ────────────────────────────────────────────────────────────
    colQuality: 'Control de qualitat',
    detailTemperature: 'Temperatura: {{value}} °C',
    detailPackaging: 'Envàs: {{status}}',
    detailLabeling: 'Etiquetatge: {{status}}',
    detailDecision: 'Decisió: {{decision}}',
    detailRecordedAt: 'Controlat el {{when}}',
    detailRecordedBy: 'Controlat per {{user}} el {{when}}',
    detailNonConformity: 'No conformitat {{code}}',
    detailNonConformityOpen: 'Obre {{code}}',
    detailNoControl: '—',
  },
} as const;
